var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-view-wrapper"},[(_vm.isEditMode())?[(_vm.bookEditMode == 'Editor')?_c('BookEdit',{attrs:{"mode":_vm.mode}}):(_vm.bookEditMode == 'HTML')?_c('BookEditHtml'):(_vm.bookEditMode == 'JSON')?_c('BookEditJson'):_c('BookEditDisplay')]:_c('CollectionGrid',{on:{"selectCollection":_vm.selectCollection,"selectBook":_vm.selectBook}}),_vm._v(" "),_c('v-dialog',{attrs:{"clickToClose":false}})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ba55238","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collections.vue
// module id = 982
// module chunks = 6